import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  Platform,
  View,
  Button,
  ScrollView,
  KeyboardAvoidingView,
  Text,
  TouchableOpacity,
} from 'react-native';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import { FlatGrid } from 'react-native-super-grid';
import { ifIphoneX } from 'react-native-iphone-x-helper';

import { AppSyncClientUnauthenticated } from '../../backends/AppSyncClient';
import GetUser from '../../q/GetUser';
import GetTheirApps from '../../q/GetTheirApps';
import AppBadge from '../../components/apps/AppBadge';
import PublisherBadge from '../../components/apps/PublisherBadge';

import styles from '../../styles';
import { translate } from '../../locales/i18n';
import App from '../../modules/data/App';
import Publisher from '../../modules/data/Publisher';

class PublisherInfo extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherInfo';

    this.state = {
    };
  }

  render() {
    const {
      publisher,
      apps,
      history,
    } = this.props;

    console.log('apps');
    console.log(apps);

    return (
      <View style={styles.view.headed}>
        <View style={styles.view.form}>
          <KeyboardAvoidingView
            style={[styles.form.container, {
              backgroundColor: 'white',
            }]}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
          >
            {!publisher ? (
              <View
                style={{
                  flex: 1,
                  width: '80%',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                }}
              >
                <Text
                  style={{
                    margin: 20,
                    ...ifIphoneX({
                      paddingTop: 40,
                    }),
                    textAlign: 'center',
                  }}
                >
                  {translate('review_user_pending')}
                </Text>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Button
                    title={translate('button_back')}
                    containerStyle={styles.button.secondaryContainer}
                    buttonStyle={styles.button.secondary}
                    disabledStyle={styles.button.secondaryDisabled}
                    titleStyle={styles.button.secondaryTitle}
                    disabledTitleStyle={styles.button.secondaryTitleDisabled}
                    onPress={() => history.go(-1)}
                  />
                </View>
              </View>
            ) : (
              <View style={{
                flex: 1,
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
              }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <PublisherBadge
                    style={{
                      marginHorizontal: 40,
                      marginVertical: 20,
                    }}
                    publisher={publisher}
                  // app={{
                  //   guideImage: publisher.image,
                  //   guideName: publisher.name,
                  //   guideDesc: publisher.desc,
                  //   guideRating: publisher.rating,
                  //   guideReviews: publisher.reviews,
                  // }}
                  />
                </View>
                {apps.length < 1 ? (
                  <View
                    style={{
                      flex: 1,
                      width: '100%',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                    }}
                  >
                    <Text>
                      {translate('user_apps_none')}
                    </Text>
                  </View>
                ) : (
                  <ScrollView
                    style={{
                      flex: 1,
                      width: '100%',
                    }}
                  >
                    <FlatGrid
                      itemDimension={310} // The lower value makes Safari wrap the price if both rent and buy are two digits prior to the decimal point
                      items={apps}
                      renderItem={
                        ({ item }) => (
                          <>
                            <TouchableOpacity onPress={() => (
                              history.push(`/ai-agent/${item.data.uuid}`)
                            )}
                            >
                              <AppBadge data={item.data} />
                            </TouchableOpacity>
                          </>
                        )
                      }
                    />
                  </ScrollView>
                )}
              </View>
            )}
          </KeyboardAvoidingView>
        </View>
      </View>
    );
  }
}

PublisherInfo.defaultProps = {
  publisher: undefined,
  apps: [],
};

PublisherInfo.propTypes = {
  publisher: PropTypes.instanceOf(Publisher),
  apps: PropTypes.arrayOf(PropTypes.instanceOf(App)),
  history: ReactRouterPropTypes.history.isRequired,
};

export default compose(
  graphql(GetUser, {
    // props: props => ({
    //   app: props.data.getMyApps,
    // }),
    props: (props) => {
      console.log('graphql props');
      console.log(props);

      if (props.data.error !== undefined
        && props.data.error.graphQLErrors !== undefined
        && props.data.error.graphQLErrors.length > 0
        && props.data.error.graphQLErrors[0].errorType === 'Unpublisherized') {
        console.log('the user is under review');
        return {
          publisher: undefined,
        };
      }

      const data = props.data.getUsers;
      if (!data) {
        return undefined;
      }

      const publisher = Publisher.createFromData(data);
      publisher.postProcess();

      return {
        publisher,
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.uuid,
      },
      client: AppSyncClientUnauthenticated,
      fetchPolicy: 'cache-and-network',
    }),
    client: AppSyncClientUnauthenticated,
  }),
  graphql(GetTheirApps, {
    props: (props) => {
      console.log('graphql returned: GetTheirApps: ');
      console.log(props.data);

      if (!props.data.queryTheirApps || !props.data.queryTheirApps.items) {
        return {
          apps: [],
        };
      }

      return {
        apps: props.data.queryTheirApps.items.map((data) => {
          const app = App.createFromData(data);
          app.postProcess();
          return app;
        }),
      };
    },
    options: (props) => ({
      variables: {
        uuid: props.uuid,
      },
      client: AppSyncClientUnauthenticated,
      fetchPolicy: 'cache-and-network',
    }),
    client: AppSyncClientUnauthenticated,
  })
)(PublisherInfo);
